import {
  ORDER_CREATE_SUCCESS,
  ORDER_EDIT_SUCCESS,
  START_LOADING_ORDERS_PAGE,
  ORDERS_PAGE_LOAD_SUCCESS,
  ORDERS_PAGE_LOAD_FAILED,
  TOGGLE_ORDER_FILTER_COLLAPSE,
  SET_ORDER_FILTER_COLLAPSE_ANIM_STATE,
  ORDERS_SET_FILTER,
  ORDERS_ADD_FILTER,
  ORDERS_REMOVE_FILTER,
  ORDERS_ADD_FILTER_DATE_FROM,
  ORDERS_ADD_FILTER_DATE_TO,
  ORDERS_REMOVE_FILTER_DATE_FROM,
  ORDERS_REMOVE_FILTER_DATE_TO,
  START_EDITING_ORDER,
  FINISH_EDITING_ORDER,
  ORDER_EDIT_FIELD,
  ORDER_FIELD_VALIDATION_ERRORS,
  ORDER_DELETE_SUCCESS,
  ORDER_CANCEL_SUCCESS,
  ORDER_SUBMIT_SUCCESS,
  ORDER_CONFIRM_SUCCESS,
  ORDERS_COMPLETE_SUCCESS,
  REFRESH_ORDERS,
  ORDERS_SELECT_ALL,
  ORDERS_DESELECT_ALL,
  ORDERS_SELECT,
  ORDERS_DESELECT,
  ORDERS_FORM_DOWNLOADED,
  MISA_ORDERS_FORM_DOWNLOADED,
  ORDER_ATTACHMENT_START_UPLOADING,
  ORDER_ATTACHMENT_UPLOAD_SUCCESS,
  ORDER_ATTACHMENT_UPLOAD_FAILED,
  ORDER_ATTACHMENT_REMOVE_SUCCESS,
  ORDERS_EMAILS_SENT,
  ORDERS_ADD_MATCHED_ORDERS,
  ORDER_GENERATE_PDF_SUCCESS,
  ORDER_GENERATE_PDF_FAILED,
} from "../actions/types";
import orderEnum from "../enum/order";

const initialState = {
  filter: {},
  filterDateFrom: {},
  filterDateTo: {},
  filterCollapsed: false,
  filterCollapseAnimating: false,
  reverse: true,
  loadingOrders: false,
  totals: {},
  orders: [],
  nextId: null,
  pageEnd: false,
  editingRow: null,
  editedFields: {},
  selectedAll: false,
  selectedIds: [],
  uploadingAttachments: [],
  fieldValidationErrors: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  const clearData = {
    totals: {},
    orders: [],
    nextId: null,
    pageEnd: false,
    selectedAll: false,
    selectedIds: [],
    fieldValidationErrors: {},
    // 新增BY ARLEN ON 20260520
    editingRow: null,
    editedFields: {},
  };
  switch (type) {
    case REFRESH_ORDERS:
    case ORDERS_COMPLETE_SUCCESS:
      return {
        ...state,
        ...clearData,
      };
    case ORDER_CREATE_SUCCESS:
      return {
        ...state,
        editingRow: payload,
        editedFields: {},
        orders: [payload, ...state.orders],
        totals: {
          ...state.totals,
          draft: (state.totals.draft || 0) + 1,
        },
      };
    case ORDER_DELETE_SUCCESS: {
      if (state.totals.draft) {
        return {
          ...state,
          orders: state.orders.filter(
            (val) =>
              !(val.status === orderEnum.status.draft && val._id === payload)
          ),
          totals: {
            ...state.totals,
            draft: state.totals.draft - 1,
          },
        };
      }
      return {
        ...state,
        ...clearData,
      };
    }
    case START_LOADING_ORDERS_PAGE:
      return {
        ...state,
        loadingOrders: true,
      };
    case ORDERS_PAGE_LOAD_SUCCESS:
      return {
        ...state,
        loadingOrders: false,
        totals: {
          ...state.totals,
          ...payload.totals,
        },
        // 第一頁載入(payload.fromId 為空)時覆蓋列表；載入下一頁才附加。
        // 否則「舊 filter 的請求較晚回來」時，舊資料會被附加到新條件的結果後面
        orders: payload.fromId ? [...state.orders, ...payload.data] : [...payload.data],
        nextId: payload.nextId,
        pageEnd: !payload.nextId,
      };
    case ORDERS_PAGE_LOAD_FAILED:
      return {
        ...state,
        loadingOrders: false,
      };
    case TOGGLE_ORDER_FILTER_COLLAPSE:
      return {
        ...state,
        filterCollapsed: !state.filterCollapsed,
      };
    case SET_ORDER_FILTER_COLLAPSE_ANIM_STATE:
      return {
        ...state,
        filterCollapseAnimating: payload,
      };
    case ORDERS_SET_FILTER:
      return {
        ...state,
        ...clearData,
        filterDateFrom: {},
        filterDateTo: {},
        filter: payload,
      };
    case ORDERS_ADD_FILTER:
      return {
        ...state,
        ...clearData,
        filter: { ...state.filter, ...payload },
      };
    case ORDERS_REMOVE_FILTER: {
      const { [payload]: _, ...newFilter } = state.filter;
      return {
        ...state,
        ...clearData,
        filter: newFilter,
      };
    }
    case ORDERS_ADD_FILTER_DATE_FROM:
      return {
        ...state,
        ...clearData,
        filterDateFrom: {
          ...state.filterDateFrom,
          ...payload.filterDate,
        },
        filter: {
          ...state.filter,
          ...Object.fromEntries(
            Object.entries(payload.filterISOString).map(([key, val]) => [
              key,
              { ...state.filter[key], $gte: val },
            ])
          ),
        },
      };
    case ORDERS_ADD_FILTER_DATE_TO:
      return {
        ...state,
        ...clearData,
        filterDateTo: {
          ...state.filterDateTo,
          ...payload.filterDate,
        },
        filter: {
          ...state.filter,
          ...Object.fromEntries(
            Object.entries(payload.filterISOString).map(([key, val]) => [
              key,
              {
                ...state.filter[key],
                $lt: val,
              },
            ])
          ),
        },
      };
    case ORDERS_REMOVE_FILTER_DATE_FROM: {
      // payload: [field_name, field_name2]
      let newFilter = {
        ...state.filter,
      };
      let removed = false;
      for (let fieldName of payload) {
        const { [fieldName]: fieldFilter, ...restNewFilter } = newFilter;
        const { $gte, ...restFieldFilter } = fieldFilter || {};
        if (!fieldFilter || !$gte) {
          continue;
        }
        removed = true;
        newFilter = {
          ...restNewFilter,
          ...(Object.keys(restFieldFilter).length > 0
            ? { [fieldName]: restFieldFilter }
            : {}),
        };
      }
      if (!removed) return state;
      return {
        ...state,
        ...clearData,
        filterDateFrom: Object.fromEntries(
          Object.entries(state.filterDateFrom).filter(
            ([key, val]) => !payload.includes(key)
          )
        ),
        filter: newFilter,
      };
    }
    case ORDERS_REMOVE_FILTER_DATE_TO: {
      let newFilter = {
        ...state.filter,
      };
      let removed = false;
      for (let fieldName of payload) {
        const { [fieldName]: fieldFilter, ...restNewFilter } = newFilter;
        const { $lt, ...restFieldFilter } = fieldFilter || {};
        if (!fieldFilter || !$lt) {
          continue;
        }
        removed = true;
        newFilter = {
          ...restNewFilter,
          ...(Object.keys(restFieldFilter).length > 0
            ? { [fieldName]: restFieldFilter }
            : {}),
        };
      }
      if (!removed) return state;
      return {
        ...state,
        ...clearData,
        filterDateTo: Object.fromEntries(
          Object.entries(state.filterDateTo).filter(
            ([key, val]) => !payload.includes(key)
          )
        ),
        filter: newFilter,
      };
    }
    case START_EDITING_ORDER:
      return {
        ...state,
        editingRow: payload,
        editedFields: {},
        fieldValidationErrors: {}
      };
    case FINISH_EDITING_ORDER:
      return {
        ...state,
        editingRow: null,
        editedFields: {},
        fieldValidationErrors: {}
      };
    case ORDER_EDIT_FIELD:
      return {
        ...state,
        editedFields: {
          ...state.editedFields,
          ...payload,
        },
        editingRow: {
          ...state.editingRow,
          ...Object.fromEntries(
            Object.entries(payload).map(([key, val]) => {
              if (
                typeof state.editingRow[key] === "object" &&
                state.editingRow[key]
              )
                // null is also an object so make sure not null
                return [key, val];
              return [key, val];
            })
          ),
        },
        // 当用户开始编辑字段时，清除该字段的验证错误
        fieldValidationErrors: Object.fromEntries(
          Object.keys(payload).map(key => [key, false])
        ),
      };
    case ORDER_FIELD_VALIDATION_ERRORS:
      return {
        ...state,
        fieldValidationErrors: payload,
      };
    case ORDER_EDIT_SUCCESS: {
      // 修正：儲存是失焦即發射的非同步請求。若用戶在儲存回應到達前已開始編輯其他欄位，
      // 不能讓回應把正在編輯的內容覆蓋掉。
      const isSameRow =
        state.editingRow && state.editingRow._id === payload._id;
      // 本次提交的欄位值快照（由 action 的 meta 帶入）
      const submitted = (action.meta && action.meta.submittedFields) || {};
      let remainingEdited = state.editedFields;

      if (isSameRow) {
        // 同一張單：只移除「已保存且值未被再次修改」的欄位；
        // 仍在編輯中的欄位（值與提交快照不同）保留，避免被後端回應覆蓋
        remainingEdited = Object.fromEntries(
          Object.entries(state.editedFields || {}).filter(
            ([k, v]) => !(k in submitted && submitted[k] === v)
          )
        );
      }
      // 其他張單的儲存回應：完全不動 editingRow / editedFields，避免誤清在途編輯

      return {
        ...state,
        editedFields: remainingEdited,
        editingRow:
          isSameRow
            ? { ...payload, ...remainingEdited }
            : state.editingRow,
        orders: state.orders.map((v) => {
          if (v._id === payload._id) {
            return payload;
          }
          return v;
        }),
      };
    }
    case ORDER_SUBMIT_SUCCESS: {
      if (state.totals.draft) {
        return {
          ...state,
          orders: [
            ...state.orders.filter(
              (val) =>
                val.status === orderEnum.status.draft &&
                val._id !== payload.draftId
            ),
            payload.order,
            ...state.orders.filter(
              (val) => val.status !== orderEnum.status.draft
            ),
          ],
          totals: {
            ...state.totals,
            draft: state.totals.draft - 1,
            submitted: (state.totals.submitted || 0) + 1,
          },
        };
      }
      return {
        ...state,
        ...clearData,
      };
    }
    case ORDER_CONFIRM_SUCCESS:
    case ORDER_CANCEL_SUCCESS: {
      // from submitted to confirmed / cancelled
      if (state.totals.submitted) {
        const status =
          type === ORDER_CONFIRM_SUCCESS
            ? orderEnum.status.confirmed
            : orderEnum.status.cancelled;
        // if set filter not the updated status, filter away
        if (state.filter.status && state.filter.status !== status) {
          return {
            ...state,
            orders: state.orders.filter((v) => {
              return v._id !== payload._id;
            }),
            totals: {
              ...state.totals,
              submitted: state.totals.submitted - 1,
            },
          };
        }
        // else update the order
        return {
          ...state,
          orders: state.orders.map((v) => {
            if (v._id === payload._id) return payload;
            return v;
          }),
          totals: {
            ...state.totals,
            submitted: state.totals.submitted - 1,
            [status]: (state.totals[status] || 0) + 1,
          },
        };
      }
      return {
        ...state,
        ...clearData,
      };
    }
    case ORDERS_SELECT_ALL:
      return {
        ...state,
        selectedAll: true,
        selectedIds: state.orders.map((val) => val._id),
      };
    case ORDERS_DESELECT_ALL:
      return {
        ...state,
        selectedAll: false,
        selectedIds: [],
      };
    case ORDERS_SELECT:
      return {
        ...state,
        selectedAll: state.selectedIds.length + 1 === state.orders.length,
        selectedIds: [...state.selectedIds, payload],
      };
    case ORDERS_DESELECT:
      return {
        ...state,
        selectedAll: false,
        selectedIds: state.selectedIds.filter((val) => val !== payload),
      };
    case ORDERS_FORM_DOWNLOADED:
      return {
        ...state,
        orders: state.orders.map((val) => {
          if (payload.includes(val._id)) {
            return {
              ...val,
              formDownloaded: true,
            };
          }
          return val;
        }),
      };
    case MISA_ORDERS_FORM_DOWNLOADED:
      return {
        ...state,
        orders: state.orders.map((val) => {
          if (payload.includes(val._id)) {
            return {
              ...val,
              formDownloaded: true,
            };
          }
          return val;
        }),
      };
    case ORDERS_EMAILS_SENT:
      return {
        ...state,
        orders: state.orders.map((val) => {
          if (payload.includes(val._id)) {
            return {
              ...val,
              emailsSent: true,
            };
          }
          return val;
        }),
      };
    case ORDERS_ADD_MATCHED_ORDERS:
      // 将匹配的订单添加到现有订单中，去重
      const existingOrderIds = new Set(state.orders.map(o => o._id));
      const newOrders = payload.filter(order => !existingOrderIds.has(order._id));
      return {
        ...state,
        orders: [...state.orders, ...newOrders],
      };
    case ORDER_GENERATE_PDF_SUCCESS:
      console.log(payload)
      return {
        ...state,
        orders: state.orders.map((val) => {
          const updated = payload.orders && payload.orders.find(item => item._id === val._id);
          console.log(updated, val)
          return updated ? updated : val;
        }),
      };
    case ORDER_GENERATE_PDF_FAILED:
      // 不清除选择框，保持当前状态
      return {
        ...state,
      };
    case ORDER_ATTACHMENT_START_UPLOADING:
      return {
        ...state,
        uploadingAttachments: [...state.uploadingAttachments, { ...payload }],
      };
    case ORDER_ATTACHMENT_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadingAttachments: state.uploadingAttachments.filter(
          (v) => v.uuid !== payload.uuid
        ),
        orders: state.orders.map((v) => {
          if (v._id === payload.order._id) {
            return payload.order;
          }
          return v;
        }),
      };
    case ORDER_ATTACHMENT_UPLOAD_FAILED:
      return {
        ...state,
        uploadingAttachments: state.uploadingAttachments.filter(
          (v) => v.uuid !== payload.uuid
        ),
      };
    case ORDER_ATTACHMENT_REMOVE_SUCCESS:
      return {
        ...state,
        orders: state.orders.map((v) => {
          if (v._id === payload._id) {
            return payload;
          }
          return v;
        }),
      };
    default:
      return state;
  }
};
